export const tourText = {
  analyticsOverview: {
    title: 'Turn data into actionable insights',
    description:
      'Track learner engagement, performance, and content effectiveness to make informed decisions.',
  },
  analyticsWelcome: {
    title: 'Welcome to aalytics',
    description: 'Realtime insights into learner progress.',
  },
  analyticsFilter: {
    title: 'Filter courses',
    description: 'Use this dropdown to filter by course.',
  },
};
